import { DomSanitizer } from '@angular/platform-browser';
import { interval } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import $ from 'jquery';

@Injectable({ providedIn: 'root' })
export default class AngularHelperService {

	private sanitizer: DomSanitizer = inject(DomSanitizer);
	
	TYPED_ARRAY_REGEXP: any = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	hasOwnProperty: any = Object.prototype.hasOwnProperty;
	
	deleteCookie(name, options) {
		options = options || {};
		var path: any = options.path;
		var expires: any = 'Thu, 01 Jan 1970 00:00:00 GMT';
		var value: any = '';
		if (this.isString(expires)) {
			expires = new Date(expires);
		}
		var str: any = encodeURIComponent(name) + '=' + encodeURIComponent(value);
		str += path ? ';path=' + path : '';
		str += options.domain ? ';domain=' + options.domain : '';
		str += expires ? ';expires=' + expires.toUTCString() : '';
		str += options.secure ? ';secure' : '';
		str += options.samesite ? ';samesite=' + options.samesite : '';
		
		document.cookie = str;
	}
	
	getWindow() {
		return window;
	}
	
	createInterval(callback, delay) {
		return interval(delay).subscribe(() => { callback(); });
	}
	
	cancelInterval(intervalReference) {
		intervalReference.unsubscribe();
	}
	
	createTimer(callback, delay?) {
		return setTimeout(() => {
			callback();
		}, delay);
	}
	
	cancelTimer(timerReference) {
		clearTimeout(timerReference);
	}
	
	getDeferredPromise() {
		var promiseImpl: any = {};
		
		promiseImpl.promise = new Promise(function(resolve, reject) {
			promiseImpl.resolve = resolve;
			promiseImpl.reject = reject;
		});
		
		return promiseImpl; // return $q.defer();
	}
	
	getPromise() {
		return Promise; // return $q;
	}
	
	trustAsResourceUrl(input) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(input);
	}
	
	trustAsHtml(input) {
		return this.sanitizer.bypassSecurityTrustHtml(input);
	}
	
	isEqual(obj1, obj2) {
		if ((obj1 === null || obj1 === undefined) && (obj2 !== null && obj2 !== undefined)) {
		    return false;
		} else if ((obj1 !== null && obj1 !== undefined) && (obj2 === null || obj2 === undefined)) {
		    return false;
		} else if ((obj1 === null || obj1 === undefined) && (obj2 === null || obj2 === undefined)) {
		    return true;
		}
		const obj1Keys = Object.keys(obj1);
		const obj2Keys = Object.keys(obj2);

		if (obj1Keys.length !== obj2Keys.length) {
			return false;
		}

		for (let objKey of obj1Keys) {
			if (obj1[objKey] !== obj2[objKey]) {
				if (typeof obj1[objKey] == "object" && typeof obj2[objKey] == "object") {
					if (!this.isEqual(obj1[objKey], obj2[objKey])) {
						return false;
					}
				} else {
					return false;
				}
			}
		}

		return true;
	}
	
	forEach(obj, iterator, context?) {
		var key, length;
		if (obj) {
			if (this.isFunction(obj)) {
				for (key in obj) {
					if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
						iterator.call(context, obj[key], key, obj);
					}
				}
			} else if (this.isArray(obj) || this.isArrayLike(obj)) {
				var isPrimitive: any = typeof obj !== 'object';
				for (key = 0, length = obj.length; key < length; key++) {
					if (isPrimitive || key in obj) {
						iterator.call(context, obj[key], key, obj);
					}
				}
			} else if (obj.forEach && obj.forEach !== this.forEach) {
				obj.forEach(iterator, context, obj);
			} else if (this.isBlankObject(obj)) {
				for (key in obj) {
					iterator.call(context, obj[key], key, obj);
				}
			} else if (typeof obj.hasOwnProperty === 'function') {
				for (key in obj) {
					if (obj.hasOwnProperty(key)) {
						iterator.call(context, obj[key], key, obj);
					}
				}
			} else {
				for (key in obj) {
					if (this.hasOwnProperty.call(obj, key)) {
						iterator.call(context, obj[key], key, obj);
					}
				}
			}
		}
		return obj;
	}
	
	isNumber(value) {
		return typeof value === 'number';
	}
	
	isFunction(value) {
		return typeof value === 'function';
	}
	
	isBlankObject(value) {
		return value !== null && typeof value === 'object' && !Object.getPrototypeOf(value);
	}
	
	isWindow(obj) {
		return obj && obj.window === obj;
	}
	
	isArray(arr) {
		return Array.isArray(arr) || arr instanceof Array;
	}
	
	isArrayLike(obj) {
		if (obj == null || this.isWindow(obj)) return false;
		if (this.isArray(obj) || this.isString(obj) /**|| (jqLite && obj instanceof jqLite)*/) return true;
		var length: any = 'length' in Object(obj) && obj.length;
		return this.isNumber(length) && (length >= 0 && (length - 1) in obj || typeof obj.item === 'function');
	}
	
	isDefined(value) {
		return typeof value !== 'undefined';
	}
	
	isDate(value) {
		return toString.call(value) === '[object Date]';
	}
	
	isRegExp(value) {
		return toString.call(value) === '[object RegExp]';
	}
	
	isScope(obj) {
		return obj && obj.$evalAsync && obj.$watch;
	}
	
	createMap() {
		return Object.create(null);
	}
	
	simpleCompare(a, b) {
		return a === b || (a !== a && b !== b);
	}
	
	equals(o1, o2) {
		if (o1 === o2) return true;
		if (o1 === null || o2 === null) return false;
		if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
		var t1: any = typeof o1, t2 = typeof o2, length, key, keySet;
		if (t1 === t2 && t1 === 'object') {
			if (this.isArray(o1)) {
				if (!this.isArray(o2)) return false;
				if ((length = o1.length) === o2.length) {
					for (key = 0; key < length; key++) {
						if (!this.equals(o1[key], o2[key])) return false;
					}
					return true;
				}
			} else if (this.isDate(o1)) {
				if (!this.isDate(o2)) return false;
				return this.simpleCompare(o1.getTime(), o2.getTime());
			} else if (this.isRegExp(o1)) {
				if (!this.isRegExp(o2)) return false;
				return o1.toString() === o2.toString();
			} else {
				if (this.isScope(o1) || this.isScope(o2) || this.isWindow(o1) || this.isWindow(o2) ||
				this.isArray(o2) || this.isDate(o2) || this.isRegExp(o2)) return false;
				keySet = this.createMap();
				for (key in o1) {
					if (key.charAt(0) === '$' || this.isFunction(o1[key])) continue;
					if (!this.equals(o1[key], o2[key])) return false;
					keySet[key] = true;
				}
				for (key in o2) {
					if (!(key in keySet) &&
					key.charAt(0) !== '$' &&
					this.isDefined(o2[key]) &&
					!this.isFunction(o2[key])) return false;
				}
				return true;
			}
		}
		return false;
	}
	
	isTypedArray(value) {
		return value && this.isNumber(value.length) && this.TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	isArrayBuffer(obj) {
		return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	isValidObjectMaxDepth(maxDepth) {
		return this.isNumber(maxDepth) && maxDepth > 0;
	}
	
	isObject(value) {
		return value !== null && typeof value === 'object';
	}
	
	setHashKey(obj, h) {
		if (h) {
			obj.$$hashKey = h;
		} else {
			delete obj.$$hashKey;
		}
	}
	
	copy(source, destination?, maxDepth?) {
		var stackSource: Array<any> = [];
		var stackDest: Array<any> = [];
		maxDepth = this.isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
		
		if (destination) {
			if (this.isTypedArray(destination) || this.isArrayBuffer(destination)) {
				throw new Error('Can\'t copy! TypedArray destination cannot be mutated.');
			}
			if (source === destination) {
				throw new Error('Can\'t copy! Source and destination are identical.');
			}
			
			// Empty the destination object
			if (this.isArray(destination)) {
				destination.length = 0;
			} else {
				this.forEach(destination, function(value, key) {
					if (key !== '$$hashKey') {
						delete destination[key];
					}
				});
			}
			
			stackSource.push(source);
			stackDest.push(destination);
			return this.copyRecurse(source, destination, maxDepth, stackSource, stackDest);
		}
		
		return this.copyElement(source, maxDepth, stackSource, stackDest);
	}
	
	copyRecurse(source, destination, maxDepth, stackSource, stackDest) {
		maxDepth--;
		if (maxDepth < 0) {
			return '...';
		}
		var h: any = destination.$$hashKey;
		var key;
		if (this.isArray(source)) {
			for (var i = 0, ii = source.length; i < ii; i++) {
				destination.push(this.copyElement(source[i], maxDepth, stackSource, stackDest));
			}
		} else if (this.isBlankObject(source)) {
			// this.createMap() fast path --- Safe to avoid this.hasOwnProperty check because prototype chain is empty
			for (key in source) {
				destination[key] = this.copyElement(source[key], maxDepth, stackSource, stackDest);
			}
		} else if (source && typeof source.hasOwnProperty === 'function') {
			// Slow path, which must rely on this.hasOwnProperty
			for (key in source) {
				if (source.hasOwnProperty(key)) {
					destination[key] = this.copyElement(source[key], maxDepth, stackSource, stackDest);
				}
			}
		} else {
			// Slowest path --- this.hasOwnProperty can't be called as a method
			for (key in source) {
				if (this.hasOwnProperty.call(source, key)) {
					destination[key] = this.copyElement(source[key], maxDepth, stackSource, stackDest);
				}
			}
		}
		this.setHashKey(destination, h);
		return destination;
	}
	
	copyElement(source, maxDepth, stackSource, stackDest) {
		// Simple values
		if (!this.isObject(source)) {
			return source;
		}
		
		// Already copied values
		var index: any = stackSource.indexOf(source);
		if (index !== -1) {
			return stackDest[index];
		}
		
		if (this.isWindow(source) || this.isScope(source)) {
			throw new Error('Can\'t copy! Making copies of Window or Scope instances is not supported.');
		}
		
		var needsRecurse: any = false;
		var destination: any = this.copyType(source, maxDepth, stackSource, stackDest);
		
		if (destination === undefined) {
			destination = this.isArray(source) ? [] : Object.create(Object.getPrototypeOf(source));
			needsRecurse = true;
		}
		
		stackSource.push(source);
		stackDest.push(destination);
		
		return needsRecurse
			? this.copyRecurse(source, destination, maxDepth, stackSource, stackDest)
			: destination;
	}
	
	copyType(source, maxDepth, stackSource, stackDest) {
		switch (toString.call(source)) {
			case '[object Int8Array]':
			case '[object Int16Array]':
			case '[object Int32Array]':
			case '[object Float32Array]':
			case '[object Float64Array]':
			case '[object Uint8Array]':
			case '[object Uint8ClampedArray]':
			case '[object Uint16Array]':
			case '[object Uint32Array]':
			return new source.constructor(this.copyElement(source.buffer, maxDepth, stackSource, stackDest), source.byteOffset, source.length);
			
			case '[object ArrayBuffer]':
			// Support: IE10
			if (!source.slice) {
				// If we're in this case we know the environment supports ArrayBuffer
				/* eslint-disable no-undef */
				var copied: any = new ArrayBuffer(source.byteLength);
				new Uint8Array(copied).set(new Uint8Array(source));
				/* eslint-enable */
				return copied;
			}
			return source.slice(0);
			
			case '[object Boolean]':
			case '[object Number]':
			case '[object String]':
			case '[object Date]':
			return new source.constructor(source.valueOf());
			
			case '[object RegExp]':
			var re: any = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
			re.lastIndex = source.lastIndex;
			return re;
			
			case '[object Blob]':
			return new source.constructor([source], { type: source.type });
		}
		
		if (this.isFunction(source.cloneNode)) {
			return source.cloneNode(true);
		}
	}
	
	isUndefined(value) {
		return typeof value === 'undefined';
	}
	
	element(input) {
		return $(input);
	}
	
	noop() {
	}
	
	identity(self) {
		return self;
	}
	
	isString(value) {
		return typeof value === 'string';
	}
	
	isPublicPath() {
		return window.location.href.includes("/benu/")
			|| window.location.href.includes("/login")
			|| window.location.href.includes("/partner-signup")
			|| window.location.href.includes("/partner-signup-success")
			|| window.location.href.includes("/register")
			|| window.location.href.includes("/reset-password")
			|| window.location.href.includes("/sk-auth")
			|| window.location.href.includes("/pre-visit-sso")
			|| window.location.href.includes("/pre-visit-chat") // not really public, but behaves like one
			|| window.location.href.includes("/verify-email")
			|| window.location.href.includes("/tallinn")
			|| window.location.href.includes("/survey")
			|| window.location.href.includes("/compliance-assessment-action/owner/") // Owner page performs its own login redirect and preserves the task URL.
			|| window.location.href.includes("/av-test")
	}
}
